import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';
import { rootRedirectPage } from './RootRedirectPage';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, rootRedirectPage],
});
